import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IResponseSettlementPeriodsLightList } from './types';

export const useGetSettlementLightList = (
  magellanAccountId: string,
  enabled = true
) => {
  const { responseHandler } = useResponseHandler();

  return useQuery<IResponseSettlementPeriodsLightList[], DefaultError>({
    queryKey: ['settlementPeriodsLightList', magellanAccountId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'SettlementPeriods/LightList',
        params: { magellanAccountId },
      });

      return responseHandler(response, {
        groupName: 'useGetSettlementLightList',
      });
    },
    enabled: enabled && !!magellanAccountId,
  });
};
